import React from 'react';
import { Box, Divider, Stack } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import { makeStyles } from "@mui/styles";
import { Offer } from "../../../../model/Offer";
import { CopyTextToClipboard } from "../../../../action/copyTextToClipboard";
import OfferUrlFactory from "../../../../infrastructure/url-factory/OfferUrlFactory";
import CompanyLogoInput from "./CompanyLogoInput";
import PhotoUrlFactory from "../../../../infrastructure/url-factory/PhotoUrlFactory";
import EditableLabel from "./EditableLabel";
import SwitchLabel from "./SwitchLabel";
import { UpdateOffer } from "../../../../action/updateOffer";
import { fileToBase64 } from "../../../../utils/file-utils";
import OfferLinks from "./OfferLinks";

const Header: React.FC<HeaderProps> = props => {
    const styles = useStyles();

    const offerId = props.offer.id;
    const { updateOffer } = props;

    return (
        <Box>
            <Box className={ styles.offerDetails2 }>
                <Grid
                    container
                    flexDirection='row'
                    spacing={ 4 }
                    alignItems='flex-start'
                    flexWrap='nowrap'
                    ml={ 0 }
                    mr={ 0 }
                >
                    <Grid xs={ 2 }>
                        <CompanyLogoInput
                            onAttach={ file => fileToBase64(file).then(base64 => updateOffer(
                                offerId,
                                { logoFileBase64: base64 }
                            )) }
                            initialPhotoUrl={ props.offer.logoFileId ? props.photoUrlFactory.url(props.offer.logoFileId) : undefined }
                        />
                    </Grid>
                    <Divider orientation='vertical' flexItem className={ styles.divider }/>
                    <Grid xs={ 4 }>
                        <Stack spacing={ 0.8 }>
                            <Box><b>Doradca</b></Box>
                            <EditableLabel
                                label='Imię i nazwisko:'
                                initialValue={ props.offer.consultant.name || '' }
                                onSave={ (value) => updateOffer(
                                    offerId,
                                    { consultant: { name: value } }
                                ) }
                            />
                            <EditableLabel
                                label='Email:'
                                initialValue={ props.offer.consultant.email || '' }
                                onSave={ (value) => updateOffer(
                                    offerId,
                                    { consultant: { email: value } }
                                ) }
                            />
                            <EditableLabel
                                label='Telefon:'
                                initialValue={ props.offer.consultant.phone || '' }
                                onSave={ (value) => updateOffer(
                                    offerId,
                                    { consultant: { phone: value } }
                                ) }
                            />
                        </Stack>
                    </Grid>

                    <Divider orientation='vertical' flexItem className={ styles.divider }/>

                    <Grid xs={ 4 } spacing={ 3 }>
                        <Stack spacing={ 0.8 }>
                            <Box><b>Oferta</b></Box>
                            <EditableLabel
                                label='Nazwa:'
                                initialValue={ props.offer.name || '' }
                                onSave={ (value) => updateOffer(
                                    offerId,
                                    { name: value }
                                ) }
                            />
                            <SwitchLabel
                                label='Pokaż ceny'
                                initialChecked={ props.offer.config.showPrices || false }
                                onChange={ (checked) => updateOffer(
                                    offerId,
                                    { config: { showPrices: checked } }
                                ) }
                            />
                        </Stack>
                    </Grid>

                    <Divider orientation='vertical' flexItem className={ styles.divider }/>

                    <Grid xs={ 2 } spacing={ 3 }>
                        <OfferLinks
                            copyTextToClipboard={ props.copyTextToClipboard }
                            offerUrlFactory={ props.offerUrlFactory }
                            offerId={ offerId }
                        />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
}
export default React.memo(Header);

export interface HeaderProps {
    readonly offer: Offer;
    readonly copyTextToClipboard: CopyTextToClipboard;
    readonly offerUrlFactory: OfferUrlFactory;
    readonly photoUrlFactory: PhotoUrlFactory;
    readonly updateOffer: UpdateOffer;
}

const useStyles = makeStyles(theme => ({
    offerDraftInfo: {
        textTransform: 'uppercase',
        backgroundColor: theme.palette.secondary.main,
        padding: theme.spacing(0.5),
        width: '100%',
        display: 'flex',
        'justify-content': 'center',
    },
    offerDetails2: {
        backgroundColor: '#ffffff',
        padding: theme.spacing(1) + ' 0',
        borderBottom: 'solid 1px ' + theme.palette.primary.main,
    },
    divider: {
        margin: theme.spacing(3) + ' 0 !important',
    },
    offerDetails: {
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.primary.contrastText,
        padding: theme.spacing(1),
        borderBottom: 'solid 1px ' + theme.palette.primary.main,
    },
    contractBtn: {
        textWrap: 'noWrap',
        marginTop: '48px !important',
        fontSize: '12px'
    },
    contractBtn_smallFont: {
        fontSize: '11px'
    }
}))